export default __webpack_public_path__ + "static/media/Hair_17_F_C2.808a8f45.svg";